export default class LivestreamProductVariationEntity {
    id: number = 0;
    size: string = '';
    stock: number = 0;
}
